import { createTranslator, type useTranslations } from "next-intl"
import type { UiLocale } from "@/lib/i18n/locales"
import english from "@/translations/en/ui-components.json"

export type UiComponentNamespace = keyof typeof english.UiComponents
export type UiComponentTranslators = {
  [Namespace in UiComponentNamespace]: ReturnType<typeof useTranslations<`UiComponents.${Namespace}`>>
}

/** Small English defaults keep shared controls usable in the visitor widget and standalone tests. */
export const englishUiComponentTranslators = getUiComponentTranslators(english, "en")

export function getUiComponentTranslators(messages: typeof english, locale: UiLocale): UiComponentTranslators {
  const namespaces = Object.keys(english.UiComponents) as UiComponentNamespace[]
  // The complete English namespace registry and checked catalog parity establish every mapped key.
  return Object.fromEntries(namespaces.map(namespace => [namespace, createTranslator({
    messages, locale, namespace: `UiComponents.${namespace}`,
  })])) as UiComponentTranslators
}
